/** Встроенный набор аватарок: без загрузки файлов, только выбор из списка. */
export const AVATARS = [
  { id: 'fox', emoji: '🦊', color: '#f97316' },
  { id: 'owl', emoji: '🦉', color: '#a16207' },
  { id: 'cat', emoji: '🐱', color: '#eab308' },
  { id: 'wolf', emoji: '🐺', color: '#64748b' },
  { id: 'raven', emoji: '🐦‍⬛', color: '#334155' },
  { id: 'bear', emoji: '🐻', color: '#92400e' },
  { id: 'frog', emoji: '🐸', color: '#16a34a' },
  { id: 'octopus', emoji: '🐙', color: '#db2777' },
  { id: 'lion', emoji: '🦁', color: '#d97706' },
  { id: 'panda', emoji: '🐼', color: '#475569' },
  { id: 'rabbit', emoji: '🐰', color: '#e11d48' },
  { id: 'snake', emoji: '🐍', color: '#15803d' },
] as const;

export type AvatarId = (typeof AVATARS)[number]['id'];
export const AVATAR_IDS = AVATARS.map((a) => a.id) as [AvatarId, ...AvatarId[]];
